import React from 'react';
import { IconBack, useDirection } from '@adc/parallax-component-library';
const TopHeaderBackArrow = ({ testID }) => {
    return (React.createElement("div", { style: {
            transform: `scaleX(${useDirection() === 'ltr' ? 1 : -1})`,
        } },
        React.createElement(IconBack, { color: "$neutral.100", testID: testID })));
};
export { TopHeaderBackArrow };
